import numeral from "numeral";
export default (value, digits = 2) => {
  let format = "0.";
  format += "0".repeat(digits);

  const _value = Math.round((parseFloat(value) + Number.EPSILON) * 100) / 100;

  return numeral(numeral(_value).format(format)).value();
};
